import { connection } from '../../utils/connection';
import { AUTH_URL } from '../../config/config';

async function LoginService(params) {
    return await connection({ method: 'POST', url: `${AUTH_URL.LOGIN}`, params: params });
}

export default LoginService;
